import { Durations, Easing, Spacings } from "@ptml/design-system";
import styled, { keyframes } from "styled-components";

const slideDownIn = keyframes`
    from {
        opacity: 0;
        transform: translate3d(0, -15%, 0);
    }
    to {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }`;

export const Container = styled.div`
    display: grid;
    grid-template-rows: auto auto 1fr;
    justify-content: center;
    row-gap: ${Spacings.medium};
    padding: ${Spacings.medium};
    margin-top: ${Spacings.large};
    width: 100%;
    max-width: 768px;

    h1,
    span {
        text-align: center;
        animation: ${slideDownIn} ${Durations.short.expand}ms
            ${Easing.decelerating.css};
        animation-fill-mode: backwards;
    }

    svg,
    img {
        align-self: center;
        justify-self: center;
    }

    h1 {
        font-size: 2.25rem !important;
        animation-delay: 260ms;
    }

    span {
        font-size: 1.25rem !important;
        animation-delay: 320ms;
        white-space: pre-line;
    }
`;
